/* eslint no-console: "off" */
class Logger {
  private name: string;

  constructor(name: string) {
    this.name = name;
  }

  log = (...args: unknown[]): void => {
    const { log } = console;
    log.apply(console, this.processArgs(args));
  };

  warn = (...args: unknown[]): void => {
    const { warn } = console;
    warn.apply(console, this.processArgs(args));
  };

  error = (...args: unknown[]): void => {
    const { error } = console;
    error.apply(console, this.processArgs(args));
  };

  private processArgs(...args: unknown[]): never {
    const result = args.slice();
    result.unshift(`[${this.name}]`);
    return result as never;
  }
}

export default Logger;
